module.exports = __webpack_public_path__ + "static/media/dm.fda8fe70.svg";